import React from "react";

export default function Sidebar({ active, onChange, sidebarOpen, showWebsite, showBusinessWebsite, showPoliticalWebsite, userName, onProfile, onLogout }) {

    return (
        <div className={`sidebar d-flex flex-column p-3 ${sidebarOpen ? "show" : ""}`}>

            {/* MAIN NAV */}
            <button
                className={`nav-btn ${active === "Dashboard" ? "active" : ""}`}
                onClick={() => onChange("Dashboard")}
            >
                <i className="bi bi-grid-fill me-2 text-purple"></i> Dashboard
            </button>

            {/* Admin Panel sections — rendered inline in this same dashboard now
                (see Admin.js), not a separate page. Still gated by
                AdminSectionGate (auto-unlocks for anyone already logged in
                to the main site — see the note there on why that's not a
                real permission system yet). */}
            {/* <button
                className={`nav-btn ${active === "AdminHomepageImages" ? "active" : ""}`}
                onClick={() => onChange("AdminHomepageImages")}
            >
                <i className="bi bi-images me-2 text-sky"></i> Homepage Images
            </button>
            <button
                className={`nav-btn ${active === "AdminAdLeads" ? "active" : ""}`}
                onClick={() => onChange("AdminAdLeads")}
            >
                <i className="bi bi-telephone-inbound-fill me-2 text-sky"></i> Ad-Leads
            </button>
            <button
                className={`nav-btn ${active === "AdminAdSegments" ? "active" : ""}`}
                onClick={() => onChange("AdminAdSegments")}
            >
                <i className="bi bi-tags-fill me-2 text-sky"></i> Ad Segment
            </button>
            <button
                className={`nav-btn ${active === "AdminBecomeAgent" ? "active" : ""}`}
                onClick={() => onChange("AdminBecomeAgent")}
            >
                <i className="bi bi-person-badge-fill me-2 text-sky"></i> Become Agent
            </button>
            <button
                className={`nav-btn ${active === "AdminAdvertisement" ? "active" : ""}`}
                onClick={() => onChange("AdminAdvertisement")}
            >
                <i className="bi bi-megaphone-fill me-2 text-sky"></i> Advertise
            </button>
           
            <button
                className={`nav-btn ${active === "AdminPageManagement" ? "active" : ""}`}
                onClick={() => onChange("AdminPageManagement")}
            >
                <i className="bi bi-file-earmark-text-fill me-2 text-sky"></i> Page Management
            </button>
            <button
                className={`nav-btn ${active === "AdminSubdomains" ? "active" : ""}`}
                onClick={() => onChange("AdminSubdomains")}
            >
                <i className="bi bi-diagram-3-fill me-2 text-sky"></i> Sub-domains
            </button>
            <button
                className={`nav-btn ${active === "AdminContactMessages" ? "active" : ""}`}
                onClick={() => onChange("AdminContactMessages")}
            >
                <i className="bi bi-envelope-fill me-2 text-sky"></i> Contact Messages
            </button> */}
            {/* <button
                className={`nav-btn ${active === "AdminWalletOverview" ? "active" : ""}`}
                onClick={() => onChange("AdminWalletOverview")}
            >
                <i className="bi bi-wallet2 me-2 text-sky"></i> Wallet Overview
            </button>  */}
            {/* <button
                className={`nav-btn ${active === "AdminRenewalHistory" ? "active" : ""}`}
                onClick={() => onChange("AdminRenewalHistory")}
            >
                <i className="bi bi-arrow-repeat me-2 text-sky"></i> Renewal History
            </button> */}
            {/* <button
                className={`nav-btn ${active === "AdminTransferOwnership" ? "active" : ""}`}
                onClick={() => onChange("AdminTransferOwnership")}
            >
                <i className="bi bi-arrow-left-right me-2 text-sky"></i> Transfer Ownership
            </button> */}

            <button
                className={`nav-btn ${active === "MyListings" ? "active" : ""}`}
                onClick={() => onChange("MyListings")}
            >
                <i className="bi bi-card-list me-2 text-green"></i> Listing
            </button>

           

            <button
                className={`nav-btn ${active === "Wallet" ? "active" : ""}`}
                onClick={() => onChange("Wallet")}
            >
                <i className="bi bi-wallet2 me-2 text-warning"></i> Wallet
            </button>

            {/* MY WEBSITES (only if the customer owns a website plan) */}
            {(showWebsite || showBusinessWebsite || showPoliticalWebsite) && (
                <button
                    className={`nav-btn ${active === "MyWebsites" ? "active" : ""}`}
                    onClick={() => onChange("MyWebsites")}
                >
                    <i className="bi bi-collection-fill me-2 text-purple"></i> My Websites
                </button>
            )}

            {/* U14: moved to the bottom of the sidebar, and made a standout
                card (not a plain list row) so business owners actually
                notice it — this is where customer leads land. */}
            <button
                className={`nav-card-highlight ${active === "AdminServiceInquiries" ? "active" : ""}`}
                onClick={() => onChange("AdminServiceInquiries")}
            >
                <span className="nav-card-icon"><i className="bi bi-headset"></i></span>
                <span className="nav-card-text">
                    <span className="nav-card-title">Service Inquiries</span>
                 
                </span>
                <i className="bi bi-chevron-right nav-card-arrow"></i>
            </button>

            {/* User profile + logout — moved here from the top-right header */}
            <div className="sb-user">
                <button className="sb-user-card" onClick={onProfile} title="View profile">
                    <img src="Profile_Avtar.png" alt="" className="sb-user-avatar" />
                    <span className="sb-user-text">
                        <span className="sb-user-name">{userName || "User"}</span>
                        <span className="sb-user-sub">View profile</span>
                    </span>
                </button>
                <div className="sb-user-actions">
                    <a className="sb-user-link" href="/"><i className="bi bi-arrow-return-left"></i> Website</a>
                    <button className="sb-user-logout" onClick={onLogout}><i className="bi bi-box-arrow-right"></i> Logout</button>
                </div>
            </div>

            <style>{`
                /* Sidebar Container */
                .sidebar {
                    width: 100%;
                    background: linear-gradient(180deg, #ffffff, #f7faff);
                    border-right: 1px solid #ececec;
                    height: 100%;
                }

                .nav-btn {
                    width: 100%;
                    border: none;
                    background: transparent;
                    padding: 12px;
                    font-size: 15px;
                    text-align: left;
                    border-radius: 8px;
                    margin-bottom: 8px;
                    color: #444;
                    cursor: pointer;
                    display: block;
                    text-decoration: none;
                    transition: 0.2s;
                }
                .nav-btn:hover {
                    background: #eef4ff;
                    transform: translateX(3px);
                }
                .nav-btn.active {
                    background: #e3ecff;
                    font-weight: 600;
                    border-left: 4px solid #2563eb;
                }

                /* U14: Service Inquiries standout card */
                .nav-card-highlight {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    border: 1px solid #dbe6ff;
                    background: linear-gradient(135deg, #eef4ff 0%, #f5f0ff 100%);
                    padding: 14px;
                    border-radius: 14px;
                    margin-top: 10px;
                    margin-bottom: 8px;
                    cursor: pointer;
                    text-align: left;
                    transition: 0.2s;
                    box-shadow: 0 2px 8px rgba(37,99,235,0.06);
                }
                .nav-card-highlight:hover {
                    box-shadow: 0 6px 16px rgba(37,99,235,0.14);
                    transform: translateY(-1px);
                    border-color: #b9cdff;
                }
                .nav-card-highlight.active {
                    border-color: #2563eb;
                    background: linear-gradient(135deg, #dfeaff 0%, #ece2ff 100%);
                }
                .nav-card-icon {
                    flex: 0 0 40px;
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    background: linear-gradient(135deg, #4a90e2, #7c5fe0);
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                }
                .nav-card-text { flex: 1; display: flex; flex-direction: column; min-width: 0; }
                .nav-card-title { font-weight: 700; font-size: 14.5px; color: #1f2937; }
                .nav-card-sub { font-size: 12px; color: #6b7280; }
                .nav-card-arrow { color: #9aa5b8; }

                /* Bottom user block */
                .sb-user { margin-top: auto; padding-top: 12px; border-top: 1px solid #e9edf3; }
                .sb-user-card { width: 100%; display: flex; align-items: center; gap: 10px; border: none; background: #f4f7fd; padding: 10px; border-radius: 12px; text-align: left; cursor: pointer; transition: 0.2s; }
                .sb-user-card:hover { background: #e9f0ff; }
                .sb-user-avatar { width: 38px; height: 38px; border-radius: 50%; border: 2px solid #e3eaff; flex-shrink: 0; }
                .sb-user-text { display: flex; flex-direction: column; min-width: 0; }
                .sb-user-name { font-weight: 700; font-size: 14px; color: #1f2937; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
                .sb-user-sub { font-size: 12px; color: #6b7280; }
                .sb-user-actions { display: flex; gap: 8px; margin-top: 8px; }
                .sb-user-link, .sb-user-logout { flex: 1; display: flex; align-items: center; justify-content: center; gap: 6px; padding: 8px; border-radius: 10px; font-size: 13px; font-weight: 600; text-decoration: none; cursor: pointer; }
                .sb-user-link { background: #fff; border: 1px solid #dfe6f3; color: #4b5563; }
                .sb-user-link:hover { background: #f4f7fd; }
                .sb-user-logout { background: #fff5f5; border: 1px solid #fbd5d5; color: #dc2626; }
                .sb-user-logout:hover { background: #fee2e2; }

                .text-purple { color: #6f42c1; }
                .text-green { color: #0d8c31; }
                .text-orange { color: #ff7f32; }
                .text-gold { color: #c49b07; }
                .text-sky { color: #0ea5e9; }
                .text-red { color: #e11d48; }

                .sub-link {
                    font-size: 14px;
                    padding-left: 12px !important;
                    margin-bottom: 6px;
                    color: #666 !important;
                }
                .sub-link:hover {
                    background: #f1f6ff;
                    border-radius: 6px;
                }

                /* Desktop Sticky */
                @media (min-width: 768px) {
                    .sidebar {
                        width: 260px;
                        position: sticky;
                        top: 56px;
                        height: calc(100vh - 56px);
                        overflow-y: auto;
                        box-shadow: 2px 0 8px rgba(0,0,0,0.05);
                    }
                }

                /* Mobile Slide */
                @media (max-width: 768px) {
                    .sidebar {
                        position: fixed;
                        top: 0;
                        left: -260px;
                        width: 240px;
                        height: 100%;
                        z-index: 1050;
                        transition: all 0.3s ease;
                        box-shadow: 0 0 12px rgba(0,0,0,0.15);
                        overflow-y: auto;
                    }
                    .sidebar.show {
                        left: 0;
                    }
                }
            `}</style>
        </div>
    );
}